/********
  * COMPONENT: USE THIS SERVICE TO MANAGE ENVIRONMENT - 
    #. Environment Level Properties.
    #. .... .... .... ....
  * @AUTHOR: IMPRESSICO(fb/gshukla67).
  * DATE: 22/10/2019.
  * UPDATE: --/--/----.
*/
import { Injectable, NgZone, ComponentFactoryResolver } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FacebookService, InitParams, LoginOptions, LoginResponse } from 'ngx-facebook';
import { AuthService } from 'angular2-google-login';

import { HttpService } from './http.service';
import { Constants } from '../app.constant';

@Injectable()
export class EnvironmentService extends HttpService {

  public response;
  public token: string;
  public customer: any[];


  public getEnvironmentProperties() {
    const requestOptionsArgs = {}; //body: { 'email': email }
    return this.getApi('/environment-properties', requestOptionsArgs, 'environemnt-level-properties')
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // public getData() {
  //   return {
  //     token: localStorage.getItem('token'),
  //     imageURL: localStorage.getItem('image'),
  //     name: localStorage.getItem('name'),
  //     email: localStorage.getItem('email'),
  //   };
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/environment.service.ts